import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from 'feather-icons-react';
import { formatPresenceDate } from "./presenceUtils";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";
import ReactToPrint from "react-to-print";

class Presence extends Component {
  state = {
    presences: [],
    staffs: [],
    months: [],
    monthId: null,
    loading: false,
  };

  componentDidMount() {
    const today = new Date();
    const month = today.getMonth() + 1;
    this.setState({ monthId: month }, () => {
      this.getMonths();
      this.getStaffs();
      this.getPresences(month);
    });
  }

  getMonths() {
    this.setState({
      months: [
        { id: 9, month: 'Septembre' },
        { id: 10, month: 'Octobre' },
        { id: 11, month: 'Novembre' },
        { id: 12, month: 'Décembre' },
        { id: 1, month: 'Janvier' },
        { id: 2, month: 'Février' },
        { id: 3, month: 'Mars' },
        { id: 4, month: 'Avril' },
        { id: 5, month: 'Mai' },
        { id: 6, month: 'Juin' },
        { id: 7, month: 'Juillet' },
        { id: 8, month: 'Août' },
      ],
    });
  }

  handleMonthChange = (e) => {
    const monthId = Number(e.target.value);
    this.setState({ monthId }, () => this.getPresences(monthId));
  };

  async getStaffs() {
    this.setState({ loading: true });
    try {
      const response = await axios.get('staffs');
      if (response.status === 200) {
        this.setState({ staffs: Array.isArray(response.data) ? response.data : [] });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  async getPresences(monthId) {
    this.setState({ loading: true });
    try {
      const response = await axios.get('presences/' + monthId);
      if (response.status === 200) {
        this.setState({ presences: Array.isArray(response.data) ? response.data : [] });
      }
    } catch (error) {
      console.error(error);
      this.setState({ presences: [] });
    } finally {
      this.setState({ loading: false });
    }
  }

  getYearForMonth(monthId) {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    return currentMonth <= 8 && monthId > currentMonth ? currentYear - 1 : currentYear;
  }

  getMonthDays(monthId) {
    if (!monthId) return [];
    const year = this.getYearForMonth(monthId);
    const days = [];
    const date = new Date(year, monthId - 1, 1);
    while (date.getMonth() === monthId - 1) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  getPresenceMap() {
    const map = new Map();
    (this.state.presences || []).forEach((presence) => {
      const staffId = presence?.staff?.id;
      const dateKey = formatPresenceDate(presence?.date);
      if (staffId && dateKey) {
        map.set(`${staffId}|${dateKey}`, presence);
      }
    });
    return map;
  }

  getTodayKey() {
    return formatPresenceDate(new Date());
  }

  getDayLabel(date) {
    const weekday = date.getDay();
    const labels = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
    return labels[weekday] || "";
  }

  getStaffLabel(staff) {
    const user = staff?.user || {};
    const parts = [staff?.matricule, user?.last_name, user?.family_name, user?.first_name].filter(Boolean);
    return parts.join(' ') || 'Personnel';
  }

  async togglePresence(staffId, dateKey, present) {
    if (!staffId || !dateKey) return;
    const presence = this.getPresenceMap().get(`${staffId}|${dateKey}`);

    if (present && presence?.id) {
      try {
        await axios.delete(`presences/${presence.id}`);
      } catch (error) {
        console.error(error);
      }
    } else if (!present) {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const time_start = `${hours}:${minutes}`;
      try {
        await axios.post('presences', { staffId, date: dateKey, time_start });
      } catch (error) {
        console.error(error);
      }
    }

    this.getPresences(this.state.monthId);
  }

  renderStats() {
    const presenceMap = this.getPresenceMap();
    const todayKey = this.getTodayKey();
    const totalMonth = presenceMap.size;
    const totalToday = Array.from(presenceMap.values()).filter((presence) => formatPresenceDate(presence.date) === todayKey).length;
    const staffCount = this.state.staffs.length;

    return (
      <div className="students-stats" aria-label="Résumé des présences">
        <article className="students-stat">
          <span className="students-stat__icon"><FeatherIcon icon="users" size={20} /></span>
          <div>
            <strong>{staffCount}</strong>
            <span>Personnel</span>
          </div>
        </article>
        <article className="students-stat">
          <span className="students-stat__icon students-stat__icon--success"><FeatherIcon icon="calendar" size={20} /></span>
          <div>
            <strong>{totalMonth}</strong>
            <span>Présences mois</span>
          </div>
        </article>
        <article className="students-stat">
          <span className="students-stat__icon students-stat__icon--purple"><FeatherIcon icon="sun" size={20} /></span>
          <div>
            <strong>{totalToday}</strong>
            <span>Aujourd'hui</span>
          </div>
        </article>
      </div>
    );
  }

  renderTableRows(days) {
    const presenceMap = this.getPresenceMap();
    const todayKey = this.getTodayKey();

    if (!this.state.staffs.length) {
      return (
        <tr>
          <td colSpan={days.length + 1} className="text-center text-muted py-4">
            Aucun membre du personnel chargé pour le moment.
          </td>
        </tr>
      );
    }

    return this.state.staffs?.sort((a, b) =>
            [a.user?.last_name, a.user?.family_name, a.user?.first_name]
            .filter(Boolean)
            .join(' ')
            .localeCompare(
                [b.user?.last_name, b.user?.family_name, b.user?.first_name]
                .filter(Boolean)
                .join(' '),
                undefined,
                { sensitivity: 'base' }
            )
        )?.map((staff) => (
      <tr key={staff.id}>
        <td className="fw-bold text-start">{this.getStaffLabel(staff)}</td>
        {days.map((day) => {
          const dayKey = formatPresenceDate(day);
          const present = presenceMap.has(`${staff.id}|${dayKey}`);
          const disabled = dayKey > todayKey || day.getDay() === 0;
          return (
            <td key={dayKey} className={`text-center presence-cell ${day.getDay() === 0 ? 'presence-sunday' : ''}`}>
              <input
                type="checkbox"
                checked={present}
                disabled={disabled}
                onChange={() => this.togglePresence(staff.id, dayKey, present)}
              />
            </td>
          );
        })}
      </tr>
    ));
  }

  render() {
    const days = this.getMonthDays(this.state.monthId);
    const splitIndex = Math.ceil(days.length / 2);
    const firstHalf = days.slice(0, splitIndex);
    const secondHalf = days.slice(splitIndex);
    const monthLabel = this.state.months.find((m) => m.id === this.state.monthId)?.month || 'Mois';

    return (
      <div className="ev-page">
        <header className="students-hero">
          <div className="students-hero__content">
            <span className="students-hero__eyebrow">Carnet de présence</span>
            <h1>Présences du personnel</h1>
            <p>Affichez le personnel et cochez les présences du mois. Les dimanches sont exclus.</p>
          </div>
          <div className="students-hero__actions">
            <select
              name="monthId"
              value={this.state.monthId || ''}
              className="form-select form-select-sm w-auto"
              onChange={this.handleMonthChange}
            >
              {this.state.months.map((month) => (
                <option key={month.id} value={month.id}>{month.month}</option>
              ))}
            </select>
            <ReactToPrint
                    trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline text-white">Imprimer</span></button>}
                    content={() => this.componentRef}
                    documentTitle={`Présences du Personnel de ${monthLabel}`}
                    pageStyle={`@page { size: A4 landscape; margin: 12mm; }`}
                />
          </div>
        </header>

        <section className="ev-page-section">
          {this.renderStats()}
        </section>

        <section className="ev-page-section">
          <div className="students-sections__heading">
            <span>Suivi</span>
            <h2>Présences de {monthLabel}</h2>
          </div>

          <div className="presence-table-wrap"  ref={el => (this.componentRef = el)}>
            <Headerpdf />
            <UserIdentity title={`Présences du Personnel de ${monthLabel}`} />
            <table className="presence-table">
              <thead>
                <tr>
                  <th rowSpan={2} className="personnel-header">Personnel</th>
                  {firstHalf.length ? <th className="presence-group" colSpan={firstHalf.length}>Semaines 1–2</th> : null}
                  {secondHalf.length ? <th className="presence-group" colSpan={secondHalf.length}>Semaines 3–4</th> : null}
                </tr>
                <tr>
                  {days.map((day) => (
                    <th key={formatPresenceDate(day)} className="presence-day" title={`${this.getDayLabel(day)} ${formatPresenceDate(day)}`}>{new Date(day).getDate()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.state.loading ? (
                  <tr>
                    <td colSpan={days.length + 1} className="text-center text-muted py-4">Chargement...</td>
                  </tr>
                ) : this.renderTableRows(days)}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    );
  }
}

export default Presence;
